<div class="scroll-container" tabindex="0">
    <div class="row my-3">
        <div class="col px-4 py-2 card">
            <pace-header [notification]="notification">
                <div class="row my-1">
                    <a class="col-12 col-lg-auto btn btn-link text-start" (click)="openEquipmentHistory()">
                        <strong translate="NOTIFICATION_DETAILS_DETAIL_LINKS_EQUIPMENTS_TITLE"></strong> -
                        <strong translate="NOTIFICATION_DETAILS_DETAIL_LINKS_EQUIPMENT_HISTORY"></strong>
                    </a>
                    <a class="col-12 col-lg-auto btn btn-link text-start" (click)="openEquipmentConfig()">
                        <strong translate="NOTIFICATION_DETAILS_DETAIL_LINKS_EQUIPMENTS_TITLE"></strong> -
                        <strong translate="NOTIFICATION_DETAILS_DETAIL_LINKS_EQUIPMENT_SUB_EQUIPMENT"></strong>
                    </a>
                </div>
                <div class="row my-1">
                    <div class="col-4 d-none d-lg-block">
                        @if (notification.userStatus) {
                            <fa-icon [icon]="faFlag" class="me-1"></fa-icon>
                        }
                        <span>{{ notification.userStatus }}</span>
                    </div>
                    <div class="col-4 d-none d-lg-block">
                        <pace-notification-status-badge
                            [notification]="notification"
                            [notificationStatus]="notification.updatedStatus"
                            [showUnreadIcon]="false"
                        ></pace-notification-status-badge>
                    </div>
                </div>
            </pace-header>
        </div>
    </div>
    <div class="row">
        <form class="col" [formGroup]="confirmationGroup">
            @if (model.equipment) {
                <pace-core-accordion
                    [accordionOpened]="model.accordionOpenedStatus.equipment"
                    (openChanged)="model.accordionOpenedStatus.equipment = true"
                    [accordionInvalid]="equipmentChildren.invalid"
                >
                    <div sectionHeader>
                        <span translate="CONFIRMATION_EQUIPMENT_LABEL"></span>
                    </div>
                    <div sectionBody>
                        <pace-confirmation-equipment
                            [model]="model.equipment"
                            [parentForm]="equipmentChildren"
                        ></pace-confirmation-equipment>
                    </div>
                    <div closeButton>
                        <span translate="CONFIRMATION_CLOSE_SECTION_LABEL"></span>
                    </div>
                </pace-core-accordion>
            }
            @if (model.complaints) {
                <pace-core-accordion
                    [accordionOpened]="model.accordionOpenedStatus.complaints"
                    (openChanged)="model.accordionOpenedStatus.complaints = true"
                    [accordionInvalid]="complaintsChildren.invalid"
                >
                    <div sectionHeader>
                        <span translate="CONFIRMATION_COMPLAINTS_LABEL"></span>
                    </div>
                    <div sectionBody>
                        <pace-confirmation-complaints-p58
                            [model]="model.complaints"
                            [parentForm]="complaintsChildren"
                        ></pace-confirmation-complaints-p58>
                    </div>
                    <div closeButton>
                        <span translate="CONFIRMATION_CLOSE_SECTION_LABEL"></span>
                    </div>
                </pace-core-accordion>
            }
            @if (model.materials) {
                <pace-core-accordion
                    [accordionOpened]="model.accordionOpenedStatus.materials"
                    (openChanged)="model.accordionOpenedStatus.materials = true"
                    [accordionInvalid]="materialsChildren.invalid"
                >
                    <div sectionHeader>
                        <span translate="CONFIRMATION_MATERIAL_LABEL"></span>
                    </div>
                    <div sectionBody>
                        <pace-confirmation-material-consume
                            [model]="model.materials"
                            [parentForm]="materialsChildren"
                        ></pace-confirmation-material-consume>
                    </div>
                    <div closeButton>
                        <span translate="CONFIRMATION_CLOSE_SECTION_LABEL"></span>
                    </div>
                </pace-core-accordion>
            }
            @if (model.measurementTool) {
                <pace-core-accordion
                    [accordionOpened]="model.accordionOpenedStatus.measurementTool"
                    (openChanged)="model.accordionOpenedStatus.measurementTool = true"
                    [accordionInvalid]="measurementToolsChildren.invalid"
                >
                    <div sectionHeader>
                        <span translate="CONFIRMATION_MEASUREMENT_TOOLS_LABEL"></span>
                    </div>
                    <div sectionBody>
                        <pace-confirmation-measurement-tools
                            [model]="model.measurementTool"
                            [parentForm]="measurementToolsChildren"
                        ></pace-confirmation-measurement-tools>
                    </div>
                    <div closeButton>
                        <span translate="CONFIRMATION_CLOSE_SECTION_LABEL"></span>
                    </div>
                </pace-core-accordion>
            }
            @if (model.measuringPoints) {
                <pace-core-accordion
                    [accordionOpened]="model.accordionOpenedStatus.measuringPoints"
                    (openChanged)="model.accordionOpenedStatus.measuringPoints = true"
                    [accordionInvalid]="measuringPointsChildren.invalid"
                >
                    <div sectionHeader>
                        <span translate="CONFIRMATION_MEASURING_POINTS_LABEL"></span>
                    </div>
                    <div sectionBody>
                        <pace-confirmation-measuring-points
                            [model]="model.measuringPoints"
                            [parentForm]="measuringPointsChildren"
                        ></pace-confirmation-measuring-points>
                    </div>
                    <div closeButton>
                        <span translate="CONFIRMATION_CLOSE_SECTION_LABEL"></span>
                    </div>
                </pace-core-accordion>
            }
            @if (model.serviceReport) {
                <pace-core-accordion
                    [accordionOpened]="model.accordionOpenedStatus.serviceReport"
                    (openChanged)="model.accordionOpenedStatus.serviceReport = true"
                    [accordionInvalid]="serviceReportChildren.invalid"
                >
                    <div sectionHeader>
                        <span translate="CONFIRMATION_SERVICE_REPORT_LABEL"></span>
                    </div>
                    <div sectionBody>
                        <pace-confirmation-service-report
                            [model]="model.serviceReport"
                            [parentForm]="serviceReportChildren"
                        ></pace-confirmation-service-report>
                    </div>
                    <div closeButton>
                        <span translate="CONFIRMATION_CLOSE_SECTION_LABEL"></span>
                    </div>
                </pace-core-accordion>
            }
            @if (model.timeRecording) {
                <pace-core-accordion
                    [accordionOpened]="model.accordionOpenedStatus.timeRecording"
                    (openChanged)="model.accordionOpenedStatus.timeRecording = true"
                    [accordionInvalid]="timeRecordingChildren.invalid"
                >
                    <div sectionHeader>
                        <span translate="CONFIRMATION_TIMERECORDING_LABEL"></span>
                    </div>
                    <div sectionBody>
                        <pace-confirmation-time-recording
                            [model]="model.timeRecording"
                            [parentForm]="timeRecordingChildren"
                        ></pace-confirmation-time-recording>
                    </div>
                    <div closeButton>
                        <span translate="CONFIRMATION_CLOSE_SECTION_LABEL"></span>
                    </div>
                </pace-core-accordion>
            }
            @if (model.expenses) {
                <pace-core-accordion
                    [accordionOpened]="model.accordionOpenedStatus.expenses"
                    (openChanged)="model.accordionOpenedStatus.expenses = true"
                    [accordionInvalid]="expensesChildren.invalid"
                >
                    <div sectionHeader>
                        <span translate="CONFIRMATION_EXPENSES_LABEL"></span>
                    </div>
                    <div sectionBody>
                        <pace-confirmation-expenses
                            [model]="model.expenses"
                            [parentForm]="expensesChildren"
                        ></pace-confirmation-expenses>
                    </div>
                    <div closeButton>
                        <span translate="CONFIRMATION_CLOSE_SECTION_LABEL"></span>
                    </div>
                </pace-core-accordion>
            }
            @if (model.installationPaperwork) {
                <pace-core-accordion
                    [accordionOpened]="model.accordionOpenedStatus.installationPaperwork"
                    (openChanged)="model.accordionOpenedStatus.installationPaperwork = true"
                    [accordionInvalid]="installationPaperworkInvalid()"
                >
                    <div sectionHeader>
                        <span translate="CONFIRMATION_INSTALLATION_PAPERWORK_LABEL"></span>
                    </div>
                    <div sectionBody>
                        <pace-confirmation-installation-paperwork
                            [model]="model.installationPaperwork"
                            [notification]="notification"
                            [parentForm]="installationPaperworkChildren"
                            (openPaceForms)="navigateToPaceForms()"
                            (updateFollowUp)="updateInstallationPaperworkFollowUp($event)"
                        ></pace-confirmation-installation-paperwork>
                    </div>
                    <div closeButton>
                        <span translate="CONFIRMATION_CLOSE_SECTION_LABEL"></span>
                    </div>
                </pace-core-accordion>
            }
            @if (model.uploadToDocBox) {
                <pace-core-accordion
                    [accordionOpened]="model.accordionOpenedStatus.uploadToDocBox"
                    (openChanged)="model.accordionOpenedStatus.uploadToDocBox = true"
                    [accordionInvalid]="uploadToDocBoxChildren.invalid"
                >
                    <div sectionHeader>
                        <span translate="CONFIRMATION_UPLOAD_TO_DOCBOX_LABEL"></span>
                    </div>
                    <div sectionBody>
                        <pace-confirmation-upload-to-docbox
                            [model]="model.uploadToDocBox"
                            [notification]="notification"
                            [parentForm]="uploadToDocBoxChildren"
                        ></pace-confirmation-upload-to-docbox>
                    </div>
                    <div closeButton>
                        <span translate="CONFIRMATION_CLOSE_SECTION_LABEL"></span>
                    </div>
                </pace-core-accordion>
            }
            @if (model.participants) {
                <pace-core-accordion
                    [accordionOpened]="model.accordionOpenedStatus.participants"
                    (openChanged)="model.accordionOpenedStatus.participants = true"
                    [accordionInvalid]="participantsChildren.invalid"
                >
                    <div sectionHeader>
                        <span translate="CONFIRMATION_PARTICIPANTLIST_LABEL"></span>
                    </div>
                    <div sectionBody>
                        <pace-confirmation-participants
                            [model]="model.participants"
                            [parentForm]="participantsChildren"
                        ></pace-confirmation-participants>
                    </div>
                    <div closeButton>
                        <span translate="CONFIRMATION_CLOSE_SECTION_LABEL"></span>
                    </div>
                </pace-core-accordion>
            }
            @if (model.sourceReplacements) {
                <pace-core-accordion
                    [accordionOpened]="model.accordionOpenedStatus.sourceReplacements"
                    (openChanged)="model.accordionOpenedStatus.sourceReplacements = true"
                    [accordionInvalid]="sourceReplacementsChildren.invalid"
                >
                    <div sectionHeader>
                        <span translate="CONFIRMATION_SOURCE_REPLACEMENTS_LABEL"></span>
                    </div>
                    <div sectionBody>
                        <pace-confirmation-source-replacements
                            [model]="model.sourceReplacements"
                            [parentForm]="sourceReplacementsChildren"
                        ></pace-confirmation-source-replacements>
                    </div>
                    <div closeButton>
                        <span translate="CONFIRMATION_CLOSE_SECTION_LABEL"></span>
                    </div>
                </pace-core-accordion>
            }
            @if (model.followup && showFollowup) {
                <pace-core-accordion
                    [accordionOpened]="model.accordionOpenedStatus.followup"
                    (openChanged)="model.accordionOpenedStatus.followup = true"
                    [accordionInvalid]="followupInvalid()"
                >
                    <div sectionHeader>
                        <span translate="CONFIRMATION_FOLLOWUP_LABEL"></span>
                    </div>
                    <div sectionBody>
                        <pace-confirmation-followup
                            [model]="model.followup"
                            [parentForm]="followupChildren"
                        ></pace-confirmation-followup>
                    </div>
                    <div closeButton>
                        <span translate="CONFIRMATION_CLOSE_SECTION_LABEL"></span>
                    </div>
                </pace-core-accordion>
            }
        </form>
    </div>
</div>

<nav class="navbar bg-light fixed-bottom safe-area-navbar-bottom" *ngrxLet="isOnline$; let isOnline">
    <ul class="navbar-nav">
        @if (showPaceFormsQuickAccess) {
            <li class="nav-item ps-2">
                <button class="btn btn-lg btn-success" type="button" (click)="navigateToPaceForms()">
                    {{ strings.paceFormsQuickAccessLabel }}
                </button>
            </li>
        }
    </ul>
    <ul class="navbar-nav flex-row flex-grow-1 justify-content-end px-2">
        <li class="nav-item me-2 d-md-block">
            <button
                class="btn btn-lg nav-item"
                [ngClass]="saveRequired() ? 'btn-primary' : 'btn-secondary'"
                type="button"
                (click)="save()"
                id="confirmationSummarySaveButton"
            >
                <span>{{ strings.saveButtonLabel }}</span>
                @if (saveRequired()) {
                    <fa-icon [icon]="faExclamationTriangle" class="text-warning"></fa-icon>
                }
            </button>
        </li>
        <li class="nav-item me-2 d-none d-md-block">
            <button
                class="btn btn-lg btn-secondary nav-item"
                type="button"
                (click)="signLater()"
                [disabled]="confirmationGroup.invalid || notAllSectionsOpened()"
            >
                {{ strings.signLaterButtonLabel }}
            </button>
        </li>
        <li class="nav-item">
            <button
                class="btn btn-lg btn-primary nav-item"
                type="button"
                (click)="sign()"
                [disabled]="confirmationGroup.invalid || notAllSectionsOpened()"
            >
                {{ strings.signButtonLabel }}
            </button>
        </li>
        <ng-template #statusButtonContent let-status="status" let-label="label">
            @switch (status) {
                @case (confirmationStatus.LOADING) {
                    <fa-icon [icon]="faLoading" animation="spin"></fa-icon>
                }
                @case (confirmationStatus.SUCCESS) {
                    {{ label }}
                    <fa-icon [icon]="faCheckCircle" class="text-success"></fa-icon>
                }
                @case (confirmationStatus.ERROR) {
                    {{ label }}
                    <fa-icon [icon]="faExclamationTriangle" class="text-danger"></fa-icon>
                }
                @case (false) {
                    {{ label }}
                    <fa-icon [icon]="faBan"></fa-icon>
                }
                @default {
                    {{ label }}
                }
            }
        </ng-template>
    </ul>
    <div class="btn-group d-md-none pe-2" dropdown [dropup]="true">
        <button
            id="button-toggler"
            dropdownToggle
            type="button"
            class="btn btn-lg btn-secondary btn-narrow"
            aria-controls="dropdown-toggler"
            [attr.aria-label]="'CONFIRMATION_ACTIONS_MENU' | translate"
        >
            <fa-icon [icon]="faEllipsisV"></fa-icon>
        </button>
        <ul
            id="dropdown-toggler"
            *dropdownMenu
            class="dropdown-menu dropdown-menu-right vw-100"
            role="menu"
            aria-labelledby="button-toggler"
        >
            <!--<ng-container *ngTemplateOutlet="saveButton; context: { extraButtonClass: 'w-100' }"></ng-container>-->
            <li class="nav-item" role="menuitem">
                <button
                    class="btn btn-lg btn-secondary nav-item w-100"
                    type="button"
                    (click)="signLater()"
                    [disabled]="confirmationGroup.invalid || notAllSectionsOpened()"
                >
                    {{ strings.signLaterButtonLabel }}
                </button>
            </li>
        </ul>
    </div>
    <ng-template #saveButton let-extraListClass="extraListClass" let-extraButtonClass="extraButtonClass">
        <li class="nav-item" [ngClass]="extraListClass || null">
            <button
                class="btn btn-lg btn-secondary nav-item"
                [ngClass]="extraButtonClass || null"
                type="button"
                (click)="save()"
                id="confirmationSummarySaveButton"
            >
                <span>{{ strings.saveButtonLabel }}</span>
            </button>
        </li>
    </ng-template>
</nav>
